export const NO_AMPLIFICATION_COLOR = '#ffda46';

// Quantile color palette for Ct values (<13, 13-16, 16-19, 19-22, 22-25, 25-28)
export const CT_QNT_COLORS = ['#550b1d', '#933b41', '#cc7878', '#dab9b7', '#cfd3ed', '#d6e7f2'] as const;

// Upper bounds for Ct colour bins - last value acts as lower bound for the neutral grey colour (>=28)
export const CT_THRESHOLDS = [13, 16, 19, 22, 25, 28] as const;

// Gradient colours for PCR efficiency (<1.7, 1.7-1.9, 1.9-2.1, 2.1-2.3, >=2.3)
export const EFF_QNT_COLORS = [
  '#D1D5DB', // neutral300 - lowest efficiency
  '#99e599',
  '#66d366',
  '#239f23',
  '#002700', // highest efficiency
] as const;

// Upper bounds for efficiency colour bins - values below the first threshold use EFF_QNT_COLORS[0]
export const EFF_THRESHOLDS = [1.7, 1.9, 2.1, 2.3] as const;

// Shared qualitative colour palette for assays, samples and curves. The first colour acts as the "default" when
// the available palette is exhausted or when a single colour is required for all entries.
export const CURVE_COLORS = [
  '#1f77b4', // blue
  '#ff7f0e', // orange
  '#2ca02c', // green
  '#d62728', // red
  '#9467bd', // purple
  '#8c564b', // brown
  '#e377c2', // pink
  '#7f7f7f', // grey
  '#bcbd22', // olive
  '#17becf', // cyan
] as const;
